import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { reactPlugin } from "./AppInsights";
import ErrorPage from "./ErrorPage";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}
const Wrapper: React.FC<ErrorBoundaryProps> = ({ children }) => <>{children}</>;

class GlobalLoggingErrorBoundary extends React.Component<ErrorBoundaryProps, { hasError: boolean }> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Log all errors globally
    console.error("[Global ErrorBoundary]", error, info);
  }

  render() {
    return this.props.children;
  }
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  return (
    <GlobalLoggingErrorBoundary>
      <AppInsightsErrorBoundary onError={ErrorPage} appInsights={reactPlugin}>
        <Wrapper>{children}</Wrapper>
      </AppInsightsErrorBoundary>
    </GlobalLoggingErrorBoundary>
  );
};

export default ErrorBoundary;
